var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4C1.25 3.58579 1.58579 3.25 2 3.25H2.00667C2.42088 3.25 2.75667 3.58579 2.75667 4C2.75667 4.41421 2.42088 4.75 2.00667 4.75H2C1.58579 4.75 1.25 4.41421 1.25 4ZM4.58333 4C4.58333 3.58579 4.91912 3.25 5.33333 3.25H14C14.4142 3.25 14.75 3.58579 14.75 4C14.75 4.41421 14.4142 4.75 14 4.75H5.33333C4.91912 4.75 4.58333 4.41421 4.58333 4ZM1.25 8C1.25 7.58579 1.58579 7.25 2 7.25H2.00667C2.42088 7.25 2.75667 7.58579 2.75667 8C2.75667 8.41421 2.42088 8.75 2.00667 8.75H2C1.58579 8.75 1.25 8.41421 1.25 8ZM4.58333 8C4.58333 7.58579 4.91912 7.25 5.33333 7.25H14C14.4142 7.25 14.75 7.58579 14.75 8C14.75 8.41421 14.4142 8.75 14 8.75H5.33333C4.91912 8.75 4.58333 8.41421 4.58333 8ZM1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H2.00667C2.42088 11.25 2.75667 11.5858 2.75667 12C2.75667 12.4142 2.42088 12.75 2.00667 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12ZM4.58333 12C4.58333 11.5858 4.91912 11.25 5.33333 11.25H14C14.4142 11.25 14.75 11.5858 14.75 12C14.75 12.4142 14.4142 12.75 14 12.75H5.33333C4.91912 12.75 4.58333 12.4142 4.58333 12Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list.d28fced3.svg";
export { ForwardRef as ReactComponent };